/**
 * Feature Flag Validator
 * Validates and sanitizes feature flag inputs
 */

import { FeatureFlag, FeatureFlagContext } from './types';

export function validateFlag(flag: any): flag is FeatureFlag {
  if (!flag || typeof flag !== 'object') return false;
  
  return (
    typeof flag.name === 'string' &&
    typeof flag.enabled === 'boolean'
  );
}

export function sanitizeFlagName(name: string): string {
  // Remove potentially dangerous characters
  return name.replace(/[^a-zA-Z0-9_.-]/g, '');
}

export function isValidContext(context: FeatureFlagContext): boolean {
  if (!context) return true;
  
  const { tenantId, userId, userRole } = context;
  
  if (tenantId && typeof tenantId !== 'string') return false;
  if (userId && typeof userId !== 'string') return false;
  if (userRole && typeof userRole !== 'string') return false;
  
  return true;
}

export function validateFlagValue(value: any): boolean {
  // Prevent XSS and injection attacks
  if (typeof value === 'string') {
    const dangerous = /<script|javascript:|on\w+=/gi;
    return !dangerous.test(value);
  }
  return true;
}
